import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=1ef6ab39&lang=pug&"
import script from "./Placeholder.vue?vue&type=script&lang=js&"
export * from "./Placeholder.vue?vue&type=script&lang=js&"
import style0 from "./Placeholder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ef6ab39')) {
      api.createRecord('1ef6ab39', component.options)
    } else {
      api.reload('1ef6ab39', component.options)
    }
    module.hot.accept("./Placeholder.vue?vue&type=template&id=1ef6ab39&lang=pug&", function () {
      api.rerender('1ef6ab39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/Placeholder.vue"
export default component.exports